export default __webpack_public_path__ + "static/media/APP_Deep_Linked_AW_Thank_You_Page.5b640c0e.png";